module.exports = __webpack_public_path__ + "static/img/yzxglbbdx.8a3b8e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welcome/yzxglbbdx.png
// module id = ileR
// module chunks = 1